export default __webpack_public_path__ + "static/media/circular-dependencies.72b5b0a8.png";